'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
require('../style-222d2b0f.js');
require('../typography/span.js');
require('../buttons-color-d198c1b7.js');
var buttonIcon = require('./button-icon.js');

var BackButton = function BackButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      text = _ref.text,
      homeIcon = _ref.homeIcon,
      backIcon = _ref.backIcon,
      downIcon = _ref.downIcon,
      props = _babelHelpers.objectWithoutProperties(_ref, ["children", "onClick", "text", "homeIcon", "backIcon", "downIcon"]);
  return React__default.createElement(
    buttonIcon.StyledButton,
    _babelHelpers._extends({
      type: "button",
      semiBold: true,
      blackText: true,
      onClick: onClick,
      tabIndex: -1,
      as: "button"
    }, props),
    downIcon && React__default.createElement(icon.Icon, { name: "chevron-down", size: "sm", margin: "0 5px 0 0" }),
    homeIcon && React__default.createElement(icon.Icon, { name: "home-line", size: "md", margin: "0 9px 0 0" }),
    backIcon && React__default.createElement(icon.Icon, { name: "chevron-left", size: "sm", margin: "0 5px 0 0" }),
    text
  );
};

BackButton.propTypes = {
  /** Button ID */
  id: PropTypes$1.string.isRequired,
  /** button text */
  text: PropTypes$1.string,
  /** indicator for button disabled state */
  disabled: PropTypes$1.bool,
  /** indicator for button size */
  large: PropTypes$1.bool,
  /** indicator for button size */
  small: PropTypes$1.bool,
  /** style for semi bold text in the component */
  semiBold: PropTypes$1.bool,
  /** style for display text in black color */
  blackText: PropTypes$1.bool,
  /** style for display text in blue color */
  blueText: PropTypes$1.bool,
  /** margin style for component */
  margin: PropTypes$1.string,
  /** padding style for component */
  padding: PropTypes$1.string,
  /** function for handle click action */
  onClick: PropTypes$1.func,
  /** indicator for show home icon */
  homeIcon: PropTypes$1.bool,
  /** indicator for show back icon */
  backIcon: PropTypes$1.bool,
  /** justify content flex */
  justifyContent: PropTypes$1.string,
  /** indicator for show downIcon */
  downIcon: PropTypes$1.bool
};

BackButton.defaultProps = {
  disabled: false,
  large: false,
  small: false,
  blackText: true,
  blueText: false,
  semiBold: false,
  downIcon: false
};
BackButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BackButton",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button disabled state"
    },
    "large": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button size"
    },
    "small": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button size"
    },
    "blackText": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for display text in black color"
    },
    "blueText": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for display text in blue color"
    },
    "semiBold": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for semi bold text in the component"
    },
    "downIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show downIcon"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Button ID"
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "button text"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin style for component"
    },
    "padding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "padding style for component"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function for handle click action"
    },
    "homeIcon": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show home icon"
    },
    "backIcon": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show back icon"
    },
    "justifyContent": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "justify content flex"
    }
  }
};

module.exports = BackButton;
//# sourceMappingURL=back.js.map
